import * as yup from "yup";

export const loadGuestSchema = (guest: any) => {
  return yup
    .object({
      first_name: yup.string().default(guest.first_name),
      last_name: yup.string().default(guest.last_name),
      instagram: yup.string().nullable().default(guest.instagram),
      phone: yup.string().nullable().default(guest.phone),
      email: yup.string().email().nullable().default(guest.email),
      color: yup.string().nullable().default(guest.color),
      notes: yup.string().nullable().default(guest.notes),
      state: yup.string().nullable().default(guest.state),
    })
    .required();
};
